// src/devTools/seedProductTypes.ts
import { auth, db } from "../firebase"; // Adjust the path to your firebase file if needed
import { doc, setDoc, serverTimestamp } from "firebase/firestore";

// Dev: massuppdatera productTypes (kräver admin-claim)
 (window as any).seedProductTypes = async () => {
  try {
    if (!auth.currentUser) {
      alert("Inte inloggad.");
      return;
    }

    type TokenClaims = {
      admin?: boolean;
      role?: string;
      roles?: { admin?: boolean };
    };
    const t = await auth.currentUser.getIdTokenResult(true);
    const claims = (t.claims ?? {}) as TokenClaims;
    const isAdmin = claims.admin === true || claims.role === "admin" || claims.roles?.admin === true;
    if (!isAdmin) {
      alert("Du är inte admin enligt dina claims.");
      console.log("claims:", claims);
      return;
    }

    // === DINA VÄRDEN ATT LÄGGA IN / UPPDATERA ===
    // Justera fritt om du vill.
    const types: Array<{
      id: string;
      label: string;
      medianWeightKg: number;
      co2PerUnitKg: number;
      active?: boolean;
      schemaVersion?: number;
    }> = [
        { id: "desktop", label: "Desktop", medianWeightKg: 7.60, co2PerUnitKg: 235, active: true, schemaVersion: 1 },
        { id: "laptop", label: "Laptop", medianWeightKg: 1.54, co2PerUnitKg: 194, active: true, schemaVersion: 1 },
        { id: "monitor", label: "Monitor", medianWeightKg: 5.90, co2PerUnitKg: 312, active: true, schemaVersion: 1 },
        { id: "printer", label: "Printer", medianWeightKg: 10.40, co2PerUnitKg: 452, active: true, schemaVersion: 1 },
        { id: "server", label: "Server", medianWeightKg: 23.13, co2PerUnitKg: 1200, active: true, schemaVersion: 1 },
        { id: "network", label: "Network product", medianWeightKg: 1.04, co2PerUnitKg: 85, active: true, schemaVersion: 1 },
        { id: "phone", label: "Phone", medianWeightKg: 0.14, co2PerUnitKg: 65, active: true, schemaVersion: 1 },
        { id: "tablet", label: "Tablet", medianWeightKg: 0.47, co2PerUnitKg: 121, active: true, schemaVersion: 1 },
        { id: "scanner", label: "Scanner", medianWeightKg: 2.34, co2PerUnitKg: 300, active: true, schemaVersion: 1 },
        { id: "pointofsales", label: "Point of sales", medianWeightKg: 7.25, co2PerUnitKg: 350, active: true, schemaVersion: 1 },
        { id: "copier", label: "Copier", medianWeightKg: 85.10, co2PerUnitKg: 2500, active: true, schemaVersion: 1 },
        { id: "dataprojector", label: "Data projector", medianWeightKg: 5.00, co2PerUnitKg: 250, active: true, schemaVersion: 1 },
      ];

    const by = auth.currentUser.email || auth.currentUser.uid || null;

    let ok = 0, fail = 0;
    for (const pt of types) {
      const ref = doc(db, "productTypes", pt.id);
      try {
        await setDoc(ref, {
          label: pt.label,
          medianWeightKg: pt.medianWeightKg,
          co2PerUnitKg: pt.co2PerUnitKg,
          schemaVersion: pt.schemaVersion ?? 1,
          active: pt.active ?? true,
          updatedAt: serverTimestamp(),
          updatedBy: by
        }, { merge: true }); // ← merge så vi inte tappar ev. befintliga fält
        ok++;
      } catch (e) {
        console.error("seed error for", pt.id, e);
        fail++;
      }
    }

    alert(`Seed klart. OK: ${ok}, Fel: ${fail}.`);
  } catch (e: any) {
    console.error("seedProductTypes:", e);
    alert("Kunde inte seeda productTypes: " + (e?.message || e));
  }
};